import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import BasicInput from "components/input/BasicInput";
import { useEffect, useMemo, useState } from "react";
import DatePickerInput from "components/input/DatePickerInput";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";
import { isValidDate } from "js/common";
import BasicButton from "components/button/BasicButton";
import { sendGet } from "api/restUtil";
import { useDaumPostcodePopup } from "react-daum-postcode";
import Float from "components/input/Float";
import CommonCodeSelect from "components/input/CommonCodeSelect";
import TimeInput from "components/input/TimeInput";
import CommonCodeCheckBox from "components/input/CommonCodeCheckBox";

/**
 * 지점 추가/수정 팝업
 */
function BranchAddModModal (props) {

	const { isOpen, onClose, initData, returnData, modalId, title } = props;
	const [ data, setData ] = useState({})
	const [ isIdDupCheck, setIsIdDupCheck ] = useState(false);
	const [ mode, setMode ] = useState("add");

	//주소 찾기 팝업
	const postCodePopup = useDaumPostcodePopup("//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js");

	const idDuplicateCheck = async (branchId) => {
		if(branchId == null || branchId == undefined || branchId === "") {
			alert("지점ID를 입력 해 주세요.");
			return;
		}
		const result = await sendGet("/api/mgmt/branch/dupCheck/" + branchId);
		if(result.respCode == "SUCCESS") {
			if(result.data == "Y") {
				alert("사용 가능한 지점ID 입니다.");
				setIsIdDupCheck(true);
			} else {
				alert("사용중인 지점ID 입니다.\n다른 ID를 사용해 주세요.");
				setIsIdDupCheck(false);
			}
		} else {
			setIsIdDupCheck(false);
		}
	}

	const onClickOk = () => {
		const requiredColumns = ["branchId", "branchName", 
			"branchAddressInfo.roadNameAddress", "branchAddressInfo.jibunAddress", "branchAddressInfo.latitude", "branchAddressInfo.longitude", 
			"activationYn", "businessRegistrationNumber", "possibleDeliveryTypes", "deliveryYn", "pickUpYn",
		];

		if(data.activationYn === false) {	// 비활성이면 비활성 사유 필수
			requiredColumns.push("activationFalseReason");
		}
		if(data?.possibleDeliveryTypes?.includes("QUICK")) {	// 퀵배달 가능이면 배달 가능 시작/종료 시각 필수
			requiredColumns.push("deliveryStartTime");
			requiredColumns.push("deliveryEndTime");
		}
		if(data?.possibleDeliveryTypes?.includes("PICKUP")) {	// 픽업 가능이면 픽업 가능 시작/종료 시각 필수
			requiredColumns.push("pickUpStartTime");
			requiredColumns.push("pickUpEndTime");
		}
		if(data?.deliveryYn === false) {	// 현재 배달 불가면 배달 중지 사유 필수
			requiredColumns.push("deliverySuspensionReason");
		}
		if(data?.pickUpYn === false) {		// 현재 픽업 불가면 픽업 중지 사유 필수
			requiredColumns.push("pickUpSuspensionReason");
		}


		// 필수 체크
		if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), data, "#branchAddModModal")) return;
		// 날짜 형식 체크
		// if(!isValidDate(data.holDt)) {
		// 	alert("날짜형식이 올바르지 않습니다.");
		// 	return;
		// }


		if(mode === "add" && !isIdDupCheck) {
			alert("지점 ID 중복 체크를 해주세요.");
			return;
		}

		if(data.hasOwnProperty("deliveryStartTime")) data.deliveryStartTime = data.deliveryStartTime.replace(":", "");
		if(data.hasOwnProperty("deliveryEndTime")) data.deliveryEndTime = data.deliveryEndTime.replace(":", "");
		if(data.hasOwnProperty("pickUpStartTime")) data.pickUpStartTime = data.pickUpStartTime.replace(":", "");
		if(data.hasOwnProperty("pickUpEndTime")) data.pickUpEndTime = data.pickUpEndTime.replace(":", "");



		returnData(data);
	}
	
	// 데이터 변경 시 invalid 제거 처리
	useEffect(() => {
		checkAndRemoveInvalid(data, "#branchAddModModal");
	}, [data]);

	const handleDataChange = (e) => {
		const {name, value} = e.target;
		let d = {...data};

		let val = value;
		// boolean은 text가 아닌 형태로 형변환
		if(value === "true") val = true;
		else if(value === "false") val = false;

		if(e.target.tagName.toLowerCase() === "input" && e.target.type.toLowerCase() === "checkbox") {
			// 체크박스는 선택 여부에 따라서 다르게 처리됨.
			val = Array.from(document.querySelectorAll("#branchAddModModal input[type='checkbox'][name=" + e.target.name + "]:checked")).map(obj => obj.value);
		}

		if(name.includes(".")) {
			let nmArr = name.split(".");
			let obj = d;
			for(let i=0; i<nmArr.length; i++) {
				const key = nmArr[i];

				if(i == nmArr.length - 1) {
					obj[key] = val;
				} else {
					if(!obj.hasOwnProperty(key)) {
						obj[key] = {};
					}
					obj = obj[key];
				}
			}

		} else {
			d[name] = val;
		}

		setData(d);
	}
	const handleDateClick = (name, value) => {
		let d = {...data};
		d[name] = value;
		setData(d);
	}

	const openPostalCodePopup = () => {
		postCodePopup({onComplete : postalCodeSelected});
	}
	const postalCodeSelected=(e)=> {
		let {roadAddress, jibunAddress, zonecode} = e;
		setData((prev)=> {
			const branchAddressInfo = prev.branchAddressInfo ?? {};
			branchAddressInfo.roadNameAddress = roadAddress;
			branchAddressInfo.jibunAddress = jibunAddress;
			
			return {...prev, branchAddressInfo: branchAddressInfo};
		});
	};

	useEffect(() => {
		setIsIdDupCheck(false);
	}, [data.branchId]);

	useEffect(() => {

		if(initData.hasOwnProperty("branchId") && initData.branchId != null && initData.branchId !== '') {
			setMode("mod");
			getBranchData(initData);
		} else {
			setMode("add");
			setDefaultValue(initData);
			setData(initData);
		}
	}, [initData]);

	// 기본 값 설정
	const setDefaultValue = async (d) => {
		if(d?.activationYn == null) d.activationYn = true;	//활성화 여부는 기본 값이 있어야 해서 설정
		if(d?.deliveryYn == null) d.deliveryYn = true;		//현재 배달 가능 여부는 기본 값이 있어야 해서 설정
		if(d?.pickUpYn == null) d.pickUpYn = true;			//현재 픽업 가능 여부는 기본 값이 있어야 해서 설정
	}

	// 지점 정보 조회
	const getBranchData = async (branchData) => {
		const result = await sendGet("/api/mgmt/branch/" + branchData.branchId);
		if(result.respCode == "SUCCESS") {
			setData(result.data);
		} else {
			alert("지점 정보 조회 실패");
			return;
		}
	}

	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal">
				<div className="me-modal-container" style={{width: "600px", height: "500px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "scroll"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="body-area modal-form" id="branchAddModModal">
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
										{/* <col width="100"/>
										<col width="200"/> */}
									</colgroup>
									<tbody>
										<tr>
											<th>지점 ID <span className="burgundy">*</span></th>
											<td>
												{mode === "add" && (
													<>
														<BasicInput item={{col: "branchId"}} value={data?.branchId} onChange={handleDataChange} width="250px" textAlign="left" />
														<BasicButton label="중복확인" onClick={()=>idDuplicateCheck(data?.branchId)} className="small-button" style={{marginLeft: "10px"}} />
													</>
												)}
												{mode === "mod" && (
													<>
														<BasicInput item={{col: "branchId"}} value={data?.branchId} readOnly={true} onChange={handleDataChange} width="250px" textAlign="left" />
													</>
												)}
											</td>
										</tr>
										<tr>
											<th>지점 명 <span className="burgundy">*</span></th>
											<td>
												<BasicInput item={{col: "branchName"}} value={data?.branchName} onChange={handleDataChange} width="250px" textAlign="left" />
											</td>
										</tr>
										<tr>
											<th>지점 연락처</th>
											<td>
												<BasicInput item={{col: "branchContactInfo"}} value={data?.branchContactInfo} onChange={handleDataChange} width="250px" textAlign="left" />
												{/* <br/>
												<span className="burgundy"> - (hyphen) 포함해서 입력 해 주세요.</span> */}
											</td>
										</tr>
										<tr>
											<th>지점 주소</th>
											<td>
												<button onClick={() => openPostalCodePopup()} className="mg-l-5 mg-r-5 mini_btn">주소찾기</button>
												<br/>
												도로명<span className="burgundy">*</span> : <BasicInput item={{col: "branchAddressInfo.roadNameAddress"}} value={data?.branchAddressInfo?.roadNameAddress} onChange={handleDataChange} width="250px" textAlign="left" readOnly={true} />
												<br/>
												지&nbsp; 번 &nbsp;<span className="burgundy">*</span> : <BasicInput item={{col: "branchAddressInfo.jibunAddress"}} value={data?.branchAddressInfo?.jibunAddress} onChange={handleDataChange} width="250px" textAlign="left" readOnly={true} />
												<br/>
												상&nbsp; 세 &nbsp; &nbsp; : <BasicInput item={{col: "branchAddressInfo.detailAddress"}} value={data?.branchAddressInfo?.detailAddress} onChange={handleDataChange} width="250px" textAlign="left" />
											</td>
										</tr>
										<tr>
											<th>지점 위치</th>
											<td>
												위&nbsp; 도 &nbsp;<span className="burgundy">*</span> : <Float className="basic-input" name={"branchAddressInfo.latitude"} value={data?.branchAddressInfo?.latitude ?? ""} decimalPlaceCnt={14} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={false} />
												<br/>
												경&nbsp; 도 &nbsp;<span className="burgundy">*</span> : <Float className="basic-input" name={"branchAddressInfo.longitude"} value={data?.branchAddressInfo?.longitude ?? ""} decimalPlaceCnt={14} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={false} />
											</td>
										</tr>
										<tr>
											<th>사업자 등록번호<span className="burgundy">*</span></th>
											<td>
												<BasicInput item={{col: "businessRegistrationNumber"}} value={data?.businessRegistrationNumber} onChange={handleDataChange} width="250px" textAlign="left" />
											</td>
										</tr>
										<tr>
											<th>활성화 여부<span className="burgundy">*</span></th>
											<td>
												<select name={"activationYn"} className="basic-input" style={{width: "100px"}} onChange={handleDataChange} value={data?.activationYn}>
													<option value={true}>활성</option>
													<option value={false}>비활성</option>
												</select>
											</td>
										</tr>
										<tr>
											<th>비활성 사유 {data?.activationYn === false && (<span className="burgundy">*</span>)}</th>
											<td>
												<CommonCodeSelect
													item={{col: "activationFalseReason", disabled: data?.activationYn}} 
													onChange={handleDataChange} 
													value={data?.activationFalseReason} 
													defaultLabel="선택" 
													grpCd="ACTIVATION_FALSE_RESAON" 
													width={100} 
												/>
											</td>
										</tr>
										<tr>
											<th>가능 배송 유형 <span className="burgundy">*</span></th>
											<td>
												<CommonCodeCheckBox
													item={{col: "possibleDeliveryTypes"}} 
													onChange={handleDataChange} 
													value={data?.possibleDeliveryTypes} 
													defaultLabel="선택" 
													grpCd="POSSIBLE_DELIVERY_TYPE" 
													width={100} 
												/>
											</td>
										</tr>
										<tr>
											<th>배달 가능 시간{data?.possibleDeliveryTypes?.includes("QUICK") && (<span className="burgundy">*</span>)}</th>
											<td>
												<TimeInput name={"deliveryStartTime"} onChange={handleDataChange} value={data?.deliveryStartTime} style={{width: "100px"}} />
												&nbsp; ~&nbsp; 
												<TimeInput name={"deliveryEndTime"} onChange={handleDataChange} value={data?.deliveryEndTime} style={{width: "100px"}} />
											</td>
										</tr>
										<tr>
											<th>픽업 가능 시간{data?.possibleDeliveryTypes?.includes("PICKUP") && (<span className="burgundy">*</span>)}</th>
											<td>
												<TimeInput name={"pickUpStartTime"} onChange={handleDataChange} value={data?.pickUpStartTime} style={{width: "100px"}} />
												&nbsp; ~&nbsp; 
												<TimeInput name={"pickUpEndTime"} onChange={handleDataChange} value={data?.pickUpEndTime} style={{width: "100px"}} />
											</td>
										</tr>
										<tr>
											<th>배달 가능 여부(현재)<span className="burgundy">*</span></th>
											<td>
												<select name={"deliveryYn"} className="basic-input" style={{width: "100px"}} onChange={handleDataChange} value={data?.deliveryYn}>
													<option value={true}>가능</option>
													<option value={false}>불가능</option>
												</select>
											</td>
										</tr>
										<tr>
											<th>배달 중지 사유 {data?.deliveryYn === false && (<span className="burgundy">*</span>)}</th>
											<td>
												<CommonCodeSelect
													item={{col: "deliverySuspensionReason", disabled: data?.deliveryYn}} 
													onChange={handleDataChange} 
													value={data?.deliverySuspensionReason} 
													defaultLabel="선택" 
													grpCd="DELIVERY_SUSPENSION_REASON" 
													width={100} 
												/>
											</td>
										</tr>
										<tr>
											<th>픽업 가능 여부(현재)<span className="burgundy">*</span></th>
											<td>
												<select name={"pickUpYn"} className="basic-input" style={{width: "100px"}} onChange={handleDataChange} value={data?.pickUpYn}>
													<option value={true}>가능</option>
													<option value={false}>불가능</option>
												</select>
											</td>
										</tr>
										<tr>
											<th>픽업 중지 사유 {data?.pickUpYn === false && (<span className="burgundy">*</span>)}</th>
											<td>
												<CommonCodeSelect
													item={{col: "pickUpSuspensionReason", disabled: data?.pickUpYn}} 
													onChange={handleDataChange} 
													value={data?.pickUpSuspensionReason} 
													defaultLabel="선택" 
													grpCd="PICKUP_SUSPENSION_REASON" 
													width={100} 
												/>
											</td>
										</tr>
										<tr>
											<th>최소 주문 가능 금액</th>
											<td>
												<Float className="basic-input" name={"minimumOrderAmount"} value={data?.minimumOrderAmount ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left"}} addComma={true} minVal={0} />
											</td>
										</tr>
										<tr>
											<th>배달 준비 시간(분)</th>
											<td>
												<Float className="basic-input" name={"deliveryPreparationMinutes"} value={data?.deliveryPreparationMinutes ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left"}} addComma={true} minVal={0} />
											</td>
										</tr>
										<tr>
											<th>배달 소요 시간(분)</th>
											<td>
												<Float className="basic-input" name={"deliveryTimeMinutes"} value={data?.deliveryTimeMinutes ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left"}} addComma={true} minVal={0} />
											</td>
										</tr>
										<tr>
											<th>배달 비용</th>
											<td>
												<Float className="basic-input" name={"deliveryCost"} value={data?.deliveryCost ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left"}} addComma={true} minVal={0} />
											</td>
										</tr>
										<tr>
											<th>봉투 비용</th>
											<td>
												<Float className="basic-input" name={"bagCost"} value={data?.bagCost ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left"}} addComma={true} minVal={0} />
											</td>
										</tr>
										<tr>
											<th>반품 배송비</th>
											<td>
												<Float className="basic-input" name={"returnCost"} value={data?.returnCost ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left"}} addComma={true} minVal={0} />
											</td>
										</tr>
										<tr>
											<th>교환 배송비</th>
											<td>
												<Float className="basic-input" name={"exchangeCost"} value={data?.exchangeCost ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left"}} addComma={true} minVal={0} />
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							{/* <div className="body-area" id="branchAddModModal">
								<div className="body-row">
									<div className="row-group">
										<div className="left">
											지점 ID <span className="burgundy">*</span>
										</div>
										<div className="right">
											<BasicInput item={{col: "branchName"}} value={data?.branchName} onChange={handleDataChange} />
											<div>
												<BasicButton label="중복확인" onClick={()=>idDuplicateCheck(data?.branchId)} className="small-button" style={{marginLeft: "10px"}} />
											</div>
										</div>
									</div>
								</div>
								<div className="body-row">
									<div className="row-group">
										<div className="left">
											날짜 <span className="burgundy">*</span>
										</div>
										<div className="right">
											<DatePickerInput
												name={"holDt"} value={data?.holDt || ""}
												onClick={(d) => handleDateClick("holDt", d)}
												onChange={handleDataChange}
											/>
										</div>
									</div>
								</div>
							</div> */}
						</div>

						<div className="me-modal-footer mg-t-10 mg-b-20">
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={onClose} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={onClickOk} style={{width: "100%"}} />

							</div>
						</div>

					</div>

				</div>
			</div>

		</ReactModal>
	);
}

export default BranchAddModModal;
